const LivingBelowChallenge1InitialText ="There are several advantages to living below your means. " +
    "Review the items in the 'Considerations' column.  If the item seems like an " +
    "advantage to you, then move the item to the 'Advantages of Living Below " +
    "Your Means' column.  When you are done, click the 'Done' button."

export default LivingBelowChallenge1InitialText 
